// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"74":"7a39967d","528":"f756bb42","684":"2ddf3fe9","895":"74ceaa3d"}[chunkId] + ".css";
};